import { AmountSuperScript } from "components/design/AmountSuperScript";
import { DISPLAY_DATE } from "constants/date";
import dayjs from "dayjs";
import { CRM_FIELD_TYPE, CrmField } from "types/Models/crmFields";

/** Read-only rendering of one CRM field value, in the shape its type calls for. */
export const CRMFieldDisplay = ({ field }: { field: CrmField }) => {
  const { field_type, value, value_display } = field;

  if (value === null || value === undefined || value === "") {
    return <span className="t-text-text-30">-</span>;
  }

  switch (field_type) {
    case CRM_FIELD_TYPE.CHECKBOX:
      return <span>{value ? "Yes" : "No"}</span>;

    case CRM_FIELD_TYPE.CURRENCY:
      return <AmountSuperScript amount={Number(value)} />;

    case CRM_FIELD_TYPE.DATE:
      return <span>{dayjs(String(value)).format(DISPLAY_DATE)}</span>;

    case CRM_FIELD_TYPE.SINGLE_SELECT:
    case CRM_FIELD_TYPE.MULTI_SELECT:
      return <span>{value_display || "-"}</span>;

    case CRM_FIELD_TYPE.LONG_TEXT:
      return <span className="t-whitespace-pre-wrap">{String(value)}</span>;

    default:
      return <span>{String(value)}</span>;
  }
};
